(function () {
  if (window.__tk9CandyRackWhitehat) return;
  window.__tk9CandyRackWhitehat = true;

  var TRUST_SUBTITLE = "Popular add-ons for cleaner, safer rides";
  var TITLE_TEXT = "Recommended Add-ons:";
  var STYLE_ID = "tk9-candyrack-whitehat-style";

  function isCandyRackFrame(frame) {
    return frame && (frame.id === "candyrack-frame" || frame.name === "candyrack-frame");
  }

  function injectFrameCleanup(frame) {
    if (!isCandyRackFrame(frame) || !frame.contentDocument) return;

    var doc = frame.contentDocument;
    if (!doc.head || !doc.body) return;

    if (!doc.getElementById(STYLE_ID)) {
      var style = doc.createElement("style");
      style.id = STYLE_ID;
      style.textContent = [
        ".Subtitle{color:#4b5563!important;font-weight:600!important;}",
        ".Offer-Price-Before-Discount,.BadgeWrapperPopup{display:none!important;visibility:hidden!important;}",
        ".Offer-Prices{gap:0!important;}",
        ".Offer-Price{color:#203b5f!important;font-weight:800!important;}",
      ].join("");
      doc.head.appendChild(style);
    }

    var title = doc.querySelector(".Title");
    if (title && /frequently bought together/i.test(title.textContent || "")) {
      title.textContent = TITLE_TEXT;
    }

    doc.querySelectorAll(".Subtitle").forEach(function (node) {
      if (/memorial day|up to|% off|free shipping over/i.test(node.textContent || "")) {
        node.textContent = TRUST_SUBTITLE;
      }
    });
  }

  function cleanCandyRackFrames() {
    document.querySelectorAll("iframe").forEach(function (frame) {
      try {
        injectFrameCleanup(frame);
      } catch (error) {
        // Candy Rack may re-render its srcdoc; the observer will retry.
      }
    });
  }

  cleanCandyRackFrames();

  var observer = new MutationObserver(cleanCandyRackFrames);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener("load", cleanCandyRackFrames);
  document.addEventListener("cart:updated", cleanCandyRackFrames);
  document.addEventListener("cart:refresh", cleanCandyRackFrames);
})();

(function () {
  if (window.__tk9CartUpsellShadowBootstrap) return;
  window.__tk9CartUpsellShadowBootstrap = true;

  function currentAssetUrl(fileName) {
    var script =
      document.currentScript ||
      document.querySelector('script[src*="tk9-candyrack-whitehat.js"]') ||
      document.querySelector('script[src*="tk9-cart-upsell-shadow.js"]');
    var src = script && script.src;
    if (!src) return "";
    return src.replace(/tk9-candyrack-whitehat\.js(?:\?[^#]*)?/, fileName);
  }

  if (!window.TeamK9CartUpsellShadowConfig) {
    window.TeamK9CartUpsellShadowConfig = {
      enabled: true,
      rulesUrl: currentAssetUrl("tk9-upsell-rules.json?v=20260606-order-shadow-v1"),
      maxVisibleOffers: 3,
      debug: false
    };
  }

  if (window.__tk9CartUpsellShadowLoaded || window.TeamK9CartUpsellShadow) return;

  var shadowSrc = currentAssetUrl("tk9-cart-upsell-shadow.js?v=20260606-order-shadow-v1");
  if (!shadowSrc) return;

  var script = document.createElement("script");
  script.src = shadowSrc;
  script.defer = true;
  document.head.appendChild(script);
})();
